import { Accessor, For, JSX, ParentProps, Show, Signal, createContext, createEffect, createMemo, createSignal, useContext } from "solid-js";
import Flexbox from "../st-flexbox/st-flexbox";
import Button from "../st-button/st-button";

import styles from './st-spinner.module.css'
import inputStyles from '../st-input/st-input.module.css'

interface SpinnerProps<T extends readonly any[], U extends JSX.Element> {
    value: Signal<T[number] | undefined>
    items: T
    children: (item: T[number], index: Accessor<number>) => U;
}

export default function Spinner<T extends readonly any[] = string[], U extends JSX.Element = string>(props: SpinnerProps<T, U>) {
    const [selectedIdx, setSelectedIdx] = createSignal(0);
    const [value, setValue] = props.value;

    function selectItem(adj: number) {
        let idx = selectedIdx() + adj;
        if (props.items?.length == 0) return;

        if (props.items) {
            idx = (idx + props.items.length) % props.items.length;
            setSelectedIdx(idx);
            setValue(props.items[idx]);
        }
    }

    return <Flexbox middle dir='horizontal' class={`${styles.spinner} ${inputStyles.input}`} >
        <Flexbox.Item auto>
            <For each={props.items}>{(it, idx) =>
                <Show when={idx() == selectedIdx()}>
                    {props.children(it, idx)}
                </Show>
            }</For>
        </Flexbox.Item>
        <Flexbox dir='vertical' class={styles.scroller}>
            <Button style="padding: 1px 2px;" type="link" label="Previous" icon="fa fa-caret-up" onClick={() => selectItem(-1)} ></Button>
            <Button style="padding: 1px 2px;" type="link" label="Next" icon="fa fa-caret-down" onClick={() => selectItem(1)}></Button>
        </Flexbox>
    </Flexbox>
}

Spinner.defaultProps = {
    value: createSignal<string | undefined>(''),
    items: [],
    children: (item: string, idx: Accessor<number>) => ''
} as SpinnerProps<string[], string>;

